import { TransformType } from 'src/app/domainObjects/transformType';
import { DataTransform } from 'src/app/domainObjects/dataTransform';
import { TransformRule } from '../transformRule';
import { DataFarmType } from '../dataFarmType';
import { SortInfo } from '../sortInfo';

export class ActivityNamingTransform extends DataTransform<ActivityNamingTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.activityNamer,nodeID);
      this.transformConfig = new ActivityNamingTransformConfig();
    }

    static fromJSON(data: any): ActivityNamingTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ActivityNamingTransform = Object.assign(new ActivityNamingTransform(0, 0, '', ''), data);
        if (instance.transformConfig) {
            instance.transformConfig = ActivityNamingTransformConfig.fromJSON(instance.transformConfig);
        }

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class ActivityNamingTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    defSourceField: string;
    defTargetField: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    groupBy: string;
    userField: string;
    timestampField: string;
    missesNamed: string;
    delMisses: boolean;
    sampleStart: number;
    sampleEnd: number;
    minLength: number;
    maxLength: number;
    runAll: boolean;
    bufferRows: number;
    threads: number;
    multiColumnTarget: boolean;
    addFields: string[];
    defTimeout: number;
    isOpenField: string;
    isCloseField: string;
    orderField: string;
    newFields: string[];
    defContainsInclude: number;
    noGroupId: string;
    // noGroupIdTimeout: number;
    separateBy: string;

    rules: ActivityNamingRule[];

    static fromJSON(data: any): ActivityNamingTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ActivityNamingTransformConfig = Object.assign(new ActivityNamingTransformConfig(), data);

        const rules: ActivityNamingRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = ActivityNamingRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class ActivityNamingRule extends TransformRule {
    sourceField: string;
    targetField: string;
    startsAt: ActivityNamingRuleType;
    endsAt: ActivityNamingRuleType;
    includeAfter = 1;
    result: string;
    contains?: string[];
    timeout = 1;
    andOr = true;
    matchCase = false;

    static fromJSON(data: any): ActivityNamingRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ActivityNamingRule = Object.assign(new ActivityNamingRule(), data);

        return instance;
    }
}

export enum ActivityNamingRuleType {
    group  = 0,
    contains = 1,
    emptyGroup = 2
}

export class ActivityNamingRuleStats {
    ruleID: number;
    activityCount: number;
    rowCount: number;
}

export class ActivityNamingPreviewStats {
    activityCount: number;
    rowCount: number;
    ruleStats: Array<ActivityNamingRuleStats>;
}
